import {
  reducer as formReducer,
  isSubmitting,
  hasSubmitSucceeded,
  hasSubmitFailed,
  formValueSelector,
} from 'redux-form';
import { transformErrors } from '../helpers/errors';

const handleErrors = (state, action) => {
  switch (action.type) {
    case '@@redux-form/SET_SUBMIT_FAILED':
      const payload = state.submitErrors;
      if (!payload) {
        return state;
      }

      const fields = state.registeredFields
        ? Object.keys(state.registeredFields)
        : [];
      const errorKeys = Object.keys(payload).filter(
        (key) => !fields.includes(key),
      );
      const error = transformErrors(errorKeys, payload);

      return {
        ...state,
        error,
      };

    default:
      return state;
  }
};

export default formReducer.plugin({
  address: handleErrors,
  device: handleErrors,
  login: handleErrors,
  sub: handleErrors,
  newUser: handleErrors,
  newChildUser: handleErrors,
  plan: handleErrors,
  user: handleErrors,
  port: handleErrors,
  portCancel: handleErrors,
  searchSubs: handleErrors,
  serviceCodes: handleErrors,
  validatePort: handleErrors,
  validateDevice: handleErrors,
  activateSub: handleErrors,
  activateAttSub: handleErrors,
  activateTracfoneSub: handleErrors,
  activateNewMdnSub: handleErrors,
  note: handleErrors,
  paymentMethods: handleErrors,
  echeckPaymentMethods: handleErrors,
  purchaseMerge: handleErrors,
  attPort: handleErrors,
  updateStatus: handleErrors,
  insuranceContract: handleErrors,
  insuranceDevice: handleErrors,
  expireSub: handleErrors,
  upgradeInvoice: handleErrors,
  changeMDNSubForm: handleErrors,
  buyoutPurchase: handleErrors,
  paymentArrangement: handleErrors,
  searchPurchases: handleErrors,
  transferLineItem: handleErrors,
  sprintCallRecord: handleErrors,
  searchContracts: handleErrors,
  addLineItems: handleErrors,
  sprintToAttStartSwitch: handleErrors,
  sprintToAttConfirmSwitch: handleErrors,
  startSwitchSprintToAtt: handleErrors,
  confirmSwitchAttToSprint: handleErrors,
  shippingEstimate: handleErrors,
  customPlanPricing: handleErrors,
  editShipping: handleErrors,
  suspendForm: handleErrors,
  createCredit: handleErrors,
  searchSimoDevices: handleErrors,
  createSimoDevice: handleErrors,
  expireDevice: handleErrors,
  suspendDevice: handleErrors,
  simoDevice: handleErrors,
  changeAccount: handleErrors,
  transferDeviceForm: handleErrors,
  changeCallerId: handleErrors,
  massChargeForm: handleErrors,
  massSuspendForm: handleErrors,
  massTransferForm: handleErrors,
  massExpireForm: handleErrors,
  massDataBlockForm: handleErrors,
  massRestoreForm: handleErrors,
  massAccountChangeForm: handleErrors,
  massActivationForm: handleErrors,
  massSyncActivationForm: handleErrors,
  voicemailPin: handleErrors,
  checkCoverageForm: handleErrors,
  validateSimForm: handleErrors,
  validateDeviceForm: handleErrors,
  validatePortForm: handleErrors,
  quickSetAddressForm: handleErrors,
  changeMdnModal: handleErrors,
  userSubsToCsvForm: handleErrors,
  updateServiceCodes: handleErrors,
});

export const getPaymentMethodSucceeded = (state) =>
  state.paymentMethods && state.paymentMethods.submitSucceeded;
export const getEcheckPaymentMethodSucceeded = (state) =>
  state.echeckPaymentMethods && state.echeckPaymentMethods.submitSucceeded;
export const getNoteSubmitSucceeded = (state) =>
  state.note && state.note.submitSucceeded;
export const getNewUserSubmitSucceeded = (state) =>
  state.newUser && state.newUser.submitSucceeded;
export const getAddressSubmitSucceeded = (state) =>
  state.address && state.address.submitSucceeded;
export const getNewSubSubmitSucceeded = (state) =>
  state.sub && state.sub.submitSucceeded;

export const getValidatePortValue = formValueSelector('validatePort');
export const getValidateDeviceValue = formValueSelector('validateDevice');

export const getBuyoutPurchaseValue = formValueSelector('buyoutPurchase');

export const getSubmitStatus = (state, formName) => {
  if (isSubmitting(formName)(state)) {
    return 'PENDING';
  } else if (hasSubmitSucceeded(formName)(state)) {
    return 'SUCCEEDED';
  } else if (hasSubmitFailed(formName)(state)) {
    return 'FAILED';
  }
};

export const getSubmitSucceeded = (state, formName) =>
  getSubmitStatus(state, formName) === 'SUCCEEDED';
export const getNewUserEmailStatus = (state) =>
  state.newUser && state.newUser.values && state.newUser.values.no_email;
export const getNewUserPhoneStatus = (state) =>
  state.newUser && state.newUser.values && state.newUser.values.no_phone;

export const getNewChildUserSubmitSucceeded = (state) => state.newChildUser && state.newChildUser.submitSucceeded;
export const getNewChildUserPhoneStatus = state => state.newChildUser && state.newChildUser.values && state.newChildUser.values.no_phone;
